var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { EventAggregator } from "aurelia-event-aggregator";
import { IFramePostMessages } from "../../models/modules/lotteryplatform-client.models";
var ExternalLogin = /** @class */ (function () {
    function ExternalLogin(router, eventAggregator) {
        var _this = this;
        this.router = router;
        this.eventAggregator = eventAggregator;
        eventAggregator.subscribe("router:navigation:complete", function (response) {
            window.removeEventListener('message', _this.redirectFunc);
        });
    }
    ExternalLogin.prototype.PostExternalLogin = function (model) {
        var _this = this;
        this.redirectFunc = function (x) {
            if (x && x.data && x.data.event == IFramePostMessages.reloadPage) {
                localStorage.setItem(IFramePostMessages.reloadPage, JSON.stringify(model));
                var router = _this.router;
                localStorage.setItem("".concat(IFramePostMessages.reloadPage, "-previous-route"), JSON.stringify({
                    routeName: router.currentInstruction.config.name,
                    params: router.currentInstruction.params
                }));
                var parentUrl = document.referrer;
                window.parent.location = parentUrl;
            }
        };
        window.parent.postMessage({
            event: "authenticationRequested",
            detail: {}
        }, "*");
        window.addEventListener('message', this.redirectFunc, true);
    };
    ExternalLogin = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router,
            EventAggregator])
    ], ExternalLogin);
    return ExternalLogin;
}());
export { ExternalLogin };
